import { DateTime } from "luxon";

export default (untilIsoStr) => {
  if (!untilIsoStr || DateTime.now().toISO() >= untilIsoStr) return "0d 0h 0m";

  const { days, hours, minutes } = DateTime.fromISO(untilIsoStr)
    .diffNow(["day", "hour", "minute"])
    .toObject();

  return `${days}d ${hours}h ${Math.floor(minutes)}m`;
};
